import { readReportSource, mutateReportSource, validateReportSource, ReportSourcePayload } from "./reportSourcePayload";

/** Call only after the selected organization's project/template access check. */
export async function loadReportDownloadSource(
  expected: Pick<ReportSourcePayload, "download_id" | "run_id" | "project_id" | "template_id">,
  fetchContext: () => Promise<any>
): Promise<ReportSourcePayload> {
  const embedded = await readReportSource();
  if (embedded) {
    validateReportSource(embedded, expected);
    const needsTraceUrl = embedded.sections?.some(
      (section: any) => !section.trace_url && (section.agent_task_id || section.chat_history_id)
    );
    if (needsTraceUrl) {
      try {
        const context = await fetchContext();
        if (Array.isArray(context?.sections)) {
          const contextById = new Map(context.sections.map((s: any) => [s.settings_group_id, s]));
          for (const section of embedded.sections) {
            if (!section.trace_url) {
              const matched: any = contextById.get(section.settings_group_id);
              if (matched?.trace_url) {
                section.trace_url = matched.trace_url;
              }
            }
          }
        }
      } catch {
        // Fall back gracefully to embedded if network/context fetch fails
      }
    }
    return embedded;
  }
  const context = await fetchContext();
  if (context.version !== 2) throw new Error("Unsupported downloaded report context.");
  const source = { ...context, version: 1, revision: 0 } as ReportSourcePayload;
  validateReportSource(source, expected);
  return mutateReportSource((current) => {
    if (current) {
      validateReportSource(current, expected);
      return current;
    }
    return source;
  });
}
